import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4dc1b62b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "pageInfo" }
const _hoisted_2 = {
  class: "text-h4 text-weight-bold",
  id: "pageTitle"
}
const _hoisted_3 = {
  key: 0,
  class: "q-py-xs",
  id: "pageDescription"
}
const _hoisted_4 = {
  key: 0,
  class: "visit-code-container"
}
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(_ctx.title)), 1),
      (_ctx.description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.description)), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.visitCodeQr?.enabled && _ctx.visitDetails?.visitCode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("b", null, _toDisplayString(_ctx.visitDetails.visitCode), 1),
          (_ctx.visitCodeQr.generatorUrl)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: `${_ctx.visitCodeQr.generatorUrl}?code=${_ctx.visitDetails.visitCode}&width=${_ctx.visitCodeQr.width}`
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}